module.exports = __webpack_public_path__ + "media/assets/icons/hl-users-677d351410de44a4754fb2dcee254adc.svg";